module.exports = __webpack_public_path__ + "img/10-small.8253d931.png";